/**
 * @generated SignedSource<<6362e5807fadd0d1c4f12fca57b8c131>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type timesheetsTeam_viewer$data = {
  readonly component: string | null;
  readonly company: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "timesheetsTeam_viewer";
};
export type timesheetsTeam_viewer$key = {
  readonly " $data"?: timesheetsTeam_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"timesheetsTeam_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "timesheetsTeam_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "team-timesheet"
        }
      ],
      "kind": "ScalarField",
      "name": "component",
      "storageKey": "component(name:\"team-timesheet\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e5034a3c27cb49e198f62a9fdd3a5b64";

export default node;
